import "./counterItemStyles.css";

const CounterItem = ({ icon, iconAlt, amount, onClick }) => {
  return (
    <div
      className="counter-item d-flex align-items-center justify-content-center px-1"
      onClick={onClick}
      {...(onClick && { style: { cursor: "pointer" } })}
    >
      <img src={icon} alt={iconAlt} />
      <span>{amount}</span>
    </div>
  );
};

export default CounterItem;
